import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import LoadStatus from 'config/load_status';

import sendVerificationEmail from 'domain/authentication/usecases/sendVerificationEmail';

import delayed from 'utils/delayed';

const useSendVerificationEmail = () => {
  const [sendEmailStatus, setSendEmailStatus] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (sendEmailStatus !== LoadStatus.LOADING) return;

    const send = async () => {
      try {
        await delayed(sendVerificationEmail());

        setSendEmailStatus(LoadStatus.DONE);
        enqueueSnackbar('Verification email was sent', { variant: 'success' });
      } catch (error) {
        setSendEmailStatus(LoadStatus.ERROR);
        enqueueSnackbar('It was not possible to send verification email', {
          variant: 'error',
        });
      }
    };
    send();
  }, [sendEmailStatus, enqueueSnackbar]);

  const sendEmail = () => {
    if (sendEmailStatus === LoadStatus.LOADING) return;

    setSendEmailStatus(LoadStatus.LOADING);
  };

  return {
    sendEmail,
    isLoading: sendEmailStatus === LoadStatus.LOADING,
  };
};

export default useSendVerificationEmail;
